
const appId = 'wx53809cc1fb3a61fc';
const redirectUrl = encodeURIComponent('');//授权回调地址
const loginStyle = 'snsapi_base';//snsapi_base 静默授权  snsapi_userinfo 用户手动授权
const param = 'STATE';//携带参数，默认不变
const fileName = '';//项目的回调的项目所在路径
const title = '';//分享的标题
const des = '';//分享的描述
const aImg = '';//分享的图片

export default {
    appId,
    redirectUrl,
    loginStyle,
    param,
    fileName,
    title,
    des,
    aImg
}


// WEBPACK FOOTER //
// ./src/jslib/wechat/wechat-param.js